<template>
	<include-header />

	<section id="lab_order">
		<div class="content">
			<div class="contIn">
				<div v-if="globaljs.acc_type === 'lab'" class="cont cont1">
					<div class="boardTitWrap">
						<div class="boardTit">금일주문현황</div>
						<div class="today">
							<div id="current_date">{{ today }}</div>
							<div>기준</div>
						</div>
					</div>
					<ul class="boardWrap">
						<li class="board cont1Board">
							<div class="orderIcon orderIcon1"></div>
							<div class="orderTxt">
								<div class="oTit">금일 주문</div>
								<div class="oNum"><span class="cGreen">{{ lab_counts?.today_order || 0 }}</span>건</div>
							</div>
						</li>
						<li class="board cont1Board">
							<div class="orderIcon orderIcon2"></div>
							<div class="orderTxt">
								<div class="oTit">리메이크</div>
								<div class="oNum"><span class="cGreen">{{ lab_counts?.today_remake || 0 }}</span>건</div>
							</div>
						</li>
						<li class="board cont1Board soon">
							<div class="authorityTxt">
								<p>*</p>
								<p>희망완료일까지 D-2로<br>출고가 임박한 주문 건의 총합입니다.</p>
							</div>
							<div class="orderIcon orderIcon3"></div>
							<div class="orderTxt">
								<div class="oTit">출고임박</div>
								<div class="oNum"><span class="cGreen">{{ lab_counts?.out_soon || 0 }}</span>건</div>
							</div>
						</li>
						<li class="board cont1Board">
							<div class="orderIcon orderIcon4"></div>
							<div class="orderTxt">
								<div class="oTit">출고 완료</div>
								<div class="oNum"><span class="cGreen">{{ lab_counts?.today_out_complete || 0 }}</span>건
								</div>
							</div>
						</li>
					</ul>
				</div>

				<div class="cont cont2">
					<ul class="boardWrap">
						<li class="cont2Board noticeBoard">
							<div class="boardTitWrap">
								<div class="boardTit" @click="page_reload()">공지사항</div>
								<div class="more" @click="commonjs.noticePopup('/board/notice')">더보기 +</div>
							</div>
							<div class="board">
								<ul class="noticeList">
									<li v-if="notices.length > 0" v-for="notice in notices"
										:class="{ 'new': today === notice.createdAt?.slice(0, 10) }">
										<div class="noticePart">[{{ notice.memberBoard?.mb_nick }}]</div>
										<div class="noticeTit">
											<p class="nTit" @click="commonjs.noticePopup(`/board_view/${notice.board_type}/${notice.real_id}`)">
												{{ notice.board_subject }}</p>
											<p class="newIcon">N</p>
										</div>
										<div class="noticeDate">{{ notice.createdAt?.slice(0, 10).replaceAll('-', '.') }}
										</div>
									</li>
									<li v-else>데이터가 없습니다.</li>
								</ul>
							</div>
						</li>

						<li class="cont2Board talkBoard">
							<div class="boardTitWrap">
								<div class="boardTit">덴탈TALK</div>
								<div class="more" @click="commonjs.talkPopup()">더보기 +</div>
							</div>
							<div class="board">
								<ul class="talkList">
									<li v-if="matchingTalks.length > 0" v-for="(item, index) in matchingTalks"
										:key="index"
										@click="commonjs.talkViewPopup(`${item.memberMatching_Hospital ? item.memberMatching_Hospital.mb_boss_id : item.memberMatching_Lab.mb_boss_id}`)"
										:class="{ 'new': (item?.talk?.allTalks?.[0]?.recv_mb_id === globaljs.mb_boss_id) && item?.talk?.allTalks?.[0]?.is_read === 'N' }">
										<div class="talkImg">
											<img v-if="item.memberMatching_Hospital ? item.memberMatching_Hospital.mb_icon : false || item.memberMatching_Lab ? item.memberMatching_Lab.mb_icon : false" :src="`${SERVER_URL}/images/member/${item.memberMatching_Hospital ? item.memberMatching_Hospital.mb_icon : item.memberMatching_Lab.mb_icon}`" style="max-width:100%;">
											<img v-else src="/img/common/profile_ex.png" style="max-width:100%;">
										</div>
										<div class="talkWrap">
											<div class="talkTit">{{ item.memberMatching_Hospital ? item.memberMatching_Hospital.mb_nick : item.memberMatching_Lab.mb_nick }}</div>
											<div class="talkTxtWrap">
												<div class="talkTxt">
													<p v-if="item?.talk?.allTalks?.length > 0" class="nTit">
														{{ item?.talk?.allTalks?.[0]?.notice === 'Y' ? '새로운 톡 알림이 있습니다.' : commonjs.replaceToBr(commonjs.stripTags(item?.talk?.allTalks?.[0]?.content)) }}</p>
													<p v-else class="nTit">시작한 대화가 없습니다.</p>
												</div>
												<p v-if="(item?.talk?.allTalks?.[0]?.recv_mb_id === globaljs.mb_boss_id) && item?.talk?.allTalks?.[0]?.is_read === 'N'" class="newIcon">N</p>
												<div class="talkDate">{{ commonjs.dateFormatYMD(item?.talk?.allTalks?.[0]?.createdAt) }}
												</div>
											</div>
										</div>
									</li>
									<li v-else>데이터가 없습니다.</li>
								</ul>
							</div>
						</li>
					</ul>
				</div>

				<div class="cont cont3">
					<div v-if="globaljs.acc_type === 'lab'" class="boardTit">주문관리 및 입출고 현황</div>
					<div v-else class="boardTit">주문관리</div>
					<ul class="boardWrap">
						<li class="board cont3Board">
							<ul v-if="globaljs.acc_type === 'lab'" class="c3Tab">
								<li class="tab1 active">주문관리</li>
								<li class="tab2">입출고 현황</li>
							</ul>
							<!-- 240426 수정 [치과에서 탭 삭제] -->
							<!-- 240426 수정 끝 -->
							<ul class="c3Tab_cont">
								<li class="box1">
									<Aiorder :perPage="20" :func_print="false" />
								</li>

								<li class="box2">
									<AiorderStatus v-if="globaljs.acc_type === 'lab'" />
								</li>
							</ul>
						</li>
					</ul>
				</div>
			</div>
		</div>
	</section>

	<include-footer />
</template>

<script>
import header from '../components/layout/header.vue'
import footer from '../components/layout/footer.vue'

export default {
	name: 'App',
	components: {
		'include-header': header,
		'include-footer': footer
	}
}
</script>

<script setup>
import { env as SERVER_URL } from '@/components/utils/env';
import { onMounted, ref, computed, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import * as globaljs from '@/components/utils/global';
import * as commonjs from '@/components/utils/common';
import Aiorder from '@/components/layout/aiorder'
import AiorderStatus from '@/components/layout/aiorder_status'

const route = useRoute();
const router = useRouter();

const today = moment().format('YYYY-MM-DD');

const lab_counts = ref([]);
const notices = ref([]);
const matchingTalks = ref([]);

onMounted(async () => {
	if (globaljs.mb_level === 1) {
		Swal.fire({
			title: '가입이 승인되지 않은 회원',
			html: `<div style="word-break: keep-all;">가입이 승인되지 않은 회원은 서비스를 이용할수 없습니다. <br>현재 계정은 로그아웃 합니다.</div>`,
			icon: 'warning',
			confirmButtonText: '확인',
			allowOutsideClick: false,  // 외부 클릭 방지
			allowEscapeKey: false,      // ESC 키 눌러서 닫기 방지
			returnFocus: false,
		}).then((result) => {
			if (result.isConfirmed) {
				setTimeout(function () {
					router.push('/logout');
				}, 100);
			}
		});
	}

	getMachingCount();
	//commonjs.DOMLoaded();
});

const getMachingCount = async () => {
	const params = new URLSearchParams();
	params.append('mb_boss_id', globaljs.mb_boss_id);
	params.append('acc_type', globaljs.acc_type);
	//params.append('mb_level', globaljs.mb_level);

	// // 만약 헤더를 명시적으로 설정해야 한다면, 아래와 같이 설정합니다.
	// const token = localStorage.getItem('token'); // 저장된 토큰을 가져옵니다.
	// const headers = {
	// 'Authorization': `Bearer ${token}`,
	// 'X-Requested-With': 'XMLHttpRequest'
	// };

	let response = await axios.get(`${SERVER_URL}/api/app/matching/count`, { params });
	if (response?.data?.result?.count < 1) {
		if ((globaljs.mb_level === 2 || globaljs.mb_level === 4) || (globaljs.mb_level !== 1 && globaljs.mb_level !== 9 && globaljs?.mb_boss_id !== globaljs.mb_id)) {
			Swal.fire({
				title: '매칭된 거래처 없음',
				html: `<div style="word-break: keep-all;">치과와 기공소가 매칭되지 않았습니다.<br/>대표계정으로 로그인 후, 매칭을 진행하세요.<br/>현재 계정은 로그아웃 합니다.</div>`,
				icon: 'warning',
				confirmButtonText: '확인',
				allowOutsideClick: false,  // 외부 클릭 방지
				allowEscapeKey: false,      // ESC 키 눌러서 닫기 방지
				returnFocus: false,
			}).then((result) => {
				if (result.isConfirmed) {
					setTimeout(function () {
						router.push('/logout');
					}, 100);
				}
			});
		} else {
			Swal.fire({
				title: '매칭된 거래처 없음',
				html: `<div style="word-break: keep-all;">거래처 매칭 페이지로 이동합니다.</div>`,
				icon: 'warning',
				confirmButtonText: '확인',
				allowOutsideClick: false,  // 외부 클릭 방지
				allowEscapeKey: false,      // ESC 키 눌러서 닫기 방지
				returnFocus: false,
			}).then((result) => {
				if (result.isConfirmed) {
					setTimeout(function () {
						router.push('/manage_partner?nopartner=y');
						//commonjs.pagePopup('/partner_add', 'partner_add');
					}, 100);
				}
			});
		}
		return false;

	} else {
		getNoticeTop5(5);
		getMatchingTalks();

		if (globaljs.acc_type === 'lab') {
			getLabCount();
		}
	}
}

const getLabCount = async () => {
	const params = new URLSearchParams();
	params.append('lab_mb_id', globaljs.mb_boss_id);

	let response = await axios.get(`${SERVER_URL}/api/app/aiorder/labcount`, { params });
console.debug(response.data.result);
	lab_counts.value = response.data.result;
}

const getNoticeTop5 = async (limit) => {
	const params = new URLSearchParams();
	params.append('board_type', 'notice')
	params.append('mb_boss_id', globaljs.mb_boss_id);
	params.append('limit', limit);
	params.append('orderBy', 'id'); // 정렬필드
	params.append('align', 'desc'); // 정렬순서

	let response = await axios.get(`${SERVER_URL}/api/app/board`, { params });
console.debug(response.data.result);
	notices.value = response.data.result;
}

const getMatchingTalks = async (limit) => {
	const params = new URLSearchParams();
	params.append('mb_boss_id', globaljs.mb_boss_id);
	params.append('acc_type', globaljs.acc_type);
	//params.append('mb_level', globaljs.mb_level);
	params.append('limit', 6); // 메인에서는 6개만

	let response = await axios.get(`${SERVER_URL}/api/app/matching/talks`, { params });
console.debug(response.data.result);
	matchingTalks.value = response.data.result;
}
</script>